module.exports = __webpack_public_path__ + "203d611b27a68b8b554dbf6983e7144c.png";